import { render } from "./HomeSidebar.vue?vue&type=template&id=3fd1d8db&scoped=true"
import script from "./HomeSidebar.vue?vue&type=script&lang=js"
export * from "./HomeSidebar.vue?vue&type=script&lang=js"

import "./HomeSidebar.vue?vue&type=style&index=0&id=3fd1d8db&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd1d8db"]])

export default __exports__